<template lang="pug">
.div
  modal-summary-order(:form="form")
  modal-session-order(:form="form", :inView="inView")
  Loader(v-if="loader")
  .container-fluid
    vm-row(class="section-summary" vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-w=6)
        div
          h2 {{ $t('strings.purchase_order') }}:
    vm-row(v-for="purcharse in requisition.purchase_order" :key="purcharse.id" :class="['section-summary__card', { 'section-summary__card--orange': purcharse.supplier_id === 1, 'section-summary__card--withe': purcharse.supplier_id > 1 }]" vm-align="center" vm-type="flex" vm-w=12)
      vm-col(class="section-summary__card__text" vm-w=10)
        div(@click="detailsPurchase(purcharse)")
          h3 {{ $t('purchase_orders.summary') }}
          span {{purcharse.folio}}
          p {{ $t('purchase_orders.information') }}
      vm-col( class="section-summary__card__button" vm-w=2)
        vm-button(@click="printPurchase(purcharse.id)" class="button_white" icon="file-add-outline" ) {{ $t('purchase_orders.download_pdf')  }}
    vm-row(class="section-summary__footer" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-type="flex" vm-align="center", vm-w=6)
          vm-button(class="button_white" @click="continueEditing()") {{ $t('requisitions_mailboxes.continue_editing')  }}
      vm-col(vm-type="flex" vm-justify="right", vm-align="center", vm-w=6)
          vm-button(@click="endOrder()") {{ $t('requisitions_mailboxes.end_order')  }}

</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')
const ModalSummaryOrder = () => import('@/components/modals/ModalSummaryOrder.vue')
const ModalSessionOrder = () => import('@/components/modals/ModalSessionOrder.vue')
const Loader = () => import('@/components/aditionals/Loader.vue')
export default {
  name: 'OrderSummary',
  components: {
    ModalSummaryOrder,
    ModalSessionOrder,
    Loader
  },
  data: () => ({
    form: {},
    inView: false
  }),
  computed: {
    ...mapGetters([
      'requisition',
      'loader'
    ])
  },
  async created () {
    this.setLoaderVisible(true)
    this.loadRequisition({ id: this.$route.params.id }).then(() => {
      this.setLoaderVisible(false)
    })
  },
  methods: {
    ...mapActions([
      'loadRequisition',
      'printPurchase',
      'setModalSummaryVisible',
      'setLoaderVisible',
      'setModalSessionOrderVisible'
    ]),
    detailsPurchase (record) {
      this.form = record
      this.setModalSummaryVisible(true)
    },
    continueEditing () {
      this.setLoaderVisible(true)
      this.$router.push({ path: `/create-purcharse-orders/${this.$route.params.id}` })
    },
    endOrder () {
      if (this.requisition.products_to_send > 0) {
        this.setModalSessionOrderVisible(true)
      } else {
        this.$router.push({ name: 'requisitions-mailboxes' })
      }
    }
  }
}
</script>
<style lang="scss">
.section-summary {
  &__card {
    &--orange {
      background-color: #d063254a;;
    }
    display: flex;
    min-height: 150px;
    border-radius: 8px;
    border: 1px solid #B1B1B1;
    padding: 25px 35px;
    position: relative;
    border-radius: 15px;
    flex-direction: row;
    box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
    -webkit-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
    -moz-box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.25);
    margin-top: 20px;
    &__text {
      display: flex;
      flex-direction: column;
      p {
        font-size: 16px;
        color: #696969;
      }
    }
    &__button {
      display: flex;
      justify-content: right;
      .vm-button {
        background-color: white !important;
        color: black !important;
        display: flex;
        border: 1px solid black;
        margin: 5px;
      }
    }
  }
  &__footer {
    margin-top: 20px;
    .button_white {
      background-color: white !important;
      color: black !important;
      display: flex;
      border: 1px solid black;
      margin: 5px;
    }
  }
}
</style>
